import "@shopify/ui-extensions/preact";
import { render } from "preact";

export default async () => {
  render(<Extension />, document.body);
};

function Extension() {
  return (
    <s-function-settings>
      <s-stack gap="base">
        <s-banner tone="info" heading="Validation ready">
          Free gift items are blocked unless their qualifying product is also in
          the cart.
        </s-banner>
        <s-text>
          This rule does not require merchant configuration. Save this rule and
          turn it on from Checkout Rules.
        </s-text>
        <s-text tone="subdued">
          Product variant mappings are managed in the app admin and synced from
          the database into a Shopify metafield for runtime validation.
        </s-text>
      </s-stack>
    </s-function-settings>
  );
}
